(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-open.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-closed-draw-open.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  PixArea = _svs$components$marke.PixArea,
  PlayButton = _svs$components$marke.PlayButton,
  TrixaButton = _svs$components$marke.TrixaButton,
  VisitGameButton = _svs$components$marke.VisitGameButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.helpers,
  capitalize = _svs$components$marke2.capitalize,
  ordinalNumber = _svs$components$marke2.ordinalNumber;
const _svs$components$marke3 = svs.components.marketplaceCompetition.overviewHero.hooks,
  useMobileQuery = _svs$components$marke3.useMobileQuery,
  useTrixa = _svs$components$marke3.useTrixa;
const _svs$components$marke4 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke4.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke4.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke4.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName,
    isMobile = _ref2.isMobile,
    showTrixa = _ref2.showTrixa;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "T\xE4vlingen har startat!")), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Du deltar inte i \xE5rets ".concat(compName, ",")), !isMobile && React.createElement("span", null, "men du kan ist\xE4llet t\xE4vla i antal kickar")), React.createElement(TrixaButton, {
    isVisible: !isMobile,
    onClick: showTrixa
  })));
};
const UserHasNoBet = _ref3 => {
  var _competition$currentD;
  let competition = _ref3.competition;
  const _ref4 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref4.firstDrawNumber,
    currentDrawNumber = _ref4.currentDrawNumber;
  const closeTime = (_competition$currentD = competition.currentDraw) !== null && _competition$currentD !== void 0 && _competition$currentD.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "L\xE4mna in ditt spel till"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "L\xE4mna in ditt spel!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, currentGameTitle), closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelstopp: ".concat(capitalize(closeTime))), React.createElement(PlayButton, {
    competition: competition
  })));
};
const UserHasBet = _ref5 => {
  var _competition$currentD2;
  let competition = _ref5.competition;
  const _ref6 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref6.firstDrawNumber,
    currentDrawNumber = _ref6.currentDrawNumber;
  const closeTime = (_competition$currentD2 = competition.currentDraw) !== null && _competition$currentD2 !== void 0 && _competition$currentD2.regCloseTime ? formatDate(competition.currentDraw.regCloseTime, true, true) : null;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement("h2", {
        "aria-label": "Du har l\xE4mnat in spelet till ".concat(ordinalNumber(round), " omg\xE5ngen"),
        className: "overview-hero-title"
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "Du har l\xE4mnat in spelet till"), React.createElement("span", {
        "aria-hidden": "true"
      }, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "Du har l\xE4mnat in spelet f\xF6r omg\xE5ngen!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, currentGameTitle, closeTime && React.createElement("div", {
    className: "overview-hero-sub-small"
  }, "Spelet startar ".concat(capitalize(closeTime))), React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionClosedDrawOpen = _ref7 => {
  let branding = _ref7.branding,
    competition = _ref7.competition,
    userState = _ref7.userState;
  const compName = resolveCompetitionName(competition);
  const isMobile = useMobileQuery();
  const _useTrixa = useTrixa(),
    _useTrixa2 = _slicedToArray(_useTrixa, 2),
    showTrixa = _useTrixa2[0],
    Trixa = _useTrixa2[1];
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName,
          isMobile: isMobile,
          showTrixa: showTrixa
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition
        });
    }
  };
  if (Trixa) {
    return React.createElement(Trixa, {
      active: true,
      branding: branding,
      classNames: "competition-overview-hero competition-closed-draw-finalized"
    });
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: clx('competition-overview-hero competition-closed-draw-open', userState)
  }, renderContentBasedOnUserState(userState)), React.createElement(PixArea, {
    branding: branding,
    competition: competition,
    isMobile: isMobile,
    isVisible: userState === HAS_NO_CURRENT_BET
  }));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionClosedDrawOpen', CompetitionClosedDrawOpen);

 })(window);